angular.module('elidb').filter('search', function(ELIService) {
    return function(listing,filters,categories) {
    	if(!listing) return listing;
        var trace = angular.trace;
    	var results = [];

        for(var i = 0, count = listing.length; i < count; i++)
        {
            var resource = listing[i];
            if(failsToMatchSearchTerm(resource)) continue;
            if(failsToSatisfyFilters(resource)) continue;
            if(failsToSatisfyResourceDependencies(resource)) continue;
            results.push(resource);
        }
    	return results;

        function failsToMatchSearchTerm(resource)
        {
            if(!filters.searchTerm) return false;

            var reg = new RegExp(filters.searchTerm,"gim");
            var tags = resource.tags;
            for(var i = 0, count = tags.length; i < count; i++)
            {
                var tag = ELIService.tagDictionary[tags[i]];
                if(tag.label.match(reg)) return false;
            }


            if(resource.name.match(reg) || 
                resource.description.match(reg) || 
                resource.city.match(reg)) return false;
            return true;
        }

        function failsToSatisfyFilters(resource)
        {
            for(var category in categories)
            {
                if(!categories[category]) continue;
                
                var selections = filters.tags[category];
                var satisfied = true;
                
                for (var selection in selections)
                {
                    if(!selections[selection]) continue;
                    if(resource.tags.indexOf(selection) == -1) satisfied = false;
                }

                if(!satisfied) return true;

               // trace("filtering on category: " + category,"selections:  " + JSON.stringify(selections), "resource: " + JSON.stringify(resource.tags),"------------------");
            }
            return false;
        }

        function failsToSatisfyResourceDependencies(resource) {
            return false;
        }
    };
});